const SETUP_KEY = "organizationFirstSetup";

export const getOrganizationFirstSetup = () => {
  try {
    const raw = sessionStorage.getItem(SETUP_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.organizationId || !parsed?.step) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const saveOrganizationFirstSetup = (state) => {
  sessionStorage.setItem(SETUP_KEY, JSON.stringify(state));
};

export const clearOrganizationFirstSetup = () => {
  sessionStorage.removeItem(SETUP_KEY);
};

export const isOrganizationFirstSetupActive = () =>
  Boolean(getOrganizationFirstSetup());
